import { API } from "aws-amplify";

export default async function getDisclosure() {
  const response = await API.get("disclosure", "");

  // code related to disclosures here

  return response
}
